export enum ImageEngineEnum {
  GPT_IMAGE_2 = 1,
  RECRAFT_V3 = 2,
  GEMINI_2_5_FLASH_IMAGE = 3,
  GEMINI_3_1_FLASH_LITE_IMAGE = 4,
  GEMINI_3_1_FLASH_IMAGE = 5,
  GEMINI_3_PRO_IMAGE = 6,
}
